﻿// JavaScript source code

if (document.getElementById("adyen-config")) {

    // Empêche qu'un nouveau cycle onSubmit/onAdditionalDetails/onOrderRequest ne démarre une fois
    // qu'un précédent a déjà décidé de rediriger la page (posé à true dès l'entrée dans paiementResult()) —
    // ex: le composant ANCV qui enchaîne sur un nouveau chèque avant que la redirection du précédent
    // n'ait eu le temps de s'exécuter. Sans ce garde-fou, plusieurs cycles concurrents peuvent chacun
    // déclencher leur propre redirection, et celui qui gagne la course réseau n'est pas forcément le
    // plus récent — symptôme observé : la vue incident d'un essai précédent reste affichée malgré un
    // paiement ANCV partiel réussi ensuite (#36921).
    let redirectionEnCours = false;

    // Masque le bloc incident (ANCV / Pay by Bank / CB, balisé data-incident-paiement dans paiement.aspx)
    // dès qu'une nouvelle tentative démarre : il concerne l'essai précédent. Sans ça, si la page n'est pas
    // re-rendue après une tentative réussie (URL restée en ?cb=refus), l'incident reste affiché à tort.
    function masquerIncidentPaiement() {
        document.querySelectorAll('[data-incident-paiement]').forEach((bloc) => {
            bloc.style.display = 'none';
        });
    }

    //  Point d'entrée appelé dans \Views\Shared\TunnelAchat\paiement\Adyen\_Index.cshtml
    async function initAdyenDropin() {

        // Garde-fou : on bloque tout montant à 0
        // On arrête avant tout appel Adyen.
        if (!configJson.Montant || configJson.Montant <= 0) {
            const container = document.querySelector('#dropin-container');
            const numero = getNumeroAgence();
            if (container) {
                container.innerHTML = '<p class="notification" style="font-weight: bold;">Le montant à régler est égal à 0, il ne peut donc pas être traité.'
                    + (numero ? ' Merci de contacter nos conseillers au ' + numero + '.' : ' Merci de contacter le service client.')
                    + '</p>';
            }
            console.error('initAdyenDropin: montant invalide (' + configJson.Montant + '), arrêt avant appel Adyen.');
            return;
        }

        var returnUrl = window.location.href;
        const urlSubmit = '/PaiementAdyen/SubmitPayment';
        const urlSubmitAdditional = '/PaiementAdyen/SubmitAdditionalDetails';
        const urlRedirect = window.location.origin + '/PaiementAdyen/PaymentResult?returnUrl=' + encodeURIComponent(returnUrl)
                                                   + '&Devise=' + configJson.Devise  + '&TypeTunnelAchat=' + configJson.TypeTunnelAchat;
        const urlSubmitInitGestionPaiement = '/PaiementAdyen/SubmitPaymentInit';
        const urlCreateOrder = '/PaiementAdyen/CreateOrder';

        // Objet contenant les infos de paiement pour adyen et pour notre gestion interne
        const infoPaiementParams = {
            Reference: configJson.Reference,
            Montant: configJson.Montant,
            DateDepart: configJson.DateDepart,
            Devise: configJson.Devise,
            CountryCode: configJson.CountryCode,
            CodePaysDestination: configJson.CodePaysDestination,
            EmailClient: configJson.EmailClient,
            TelephoneClient: configJson.TelephoneClient,
            ReturnUrl: urlRedirect,
            ModePaiement: configJson.ModePaiement,
            TypeTunnelAchat: configJson.TypeTunnelAchat,
            TypeLibelleSoldeAPayer: configJson.TypeLibelleSoldeAPayer,
            SuccesPaiement: false,
            BillingAddress: configJson.BillingAddress,
            // Reprise d'un Order Adyen existant (ex: paiement ANCV partiel, solde à régler avec un
            // autre moyen de paiement) — transmis par le serveur si un paiement précédent est incomplet.
            OrderPspReference: configJson.OrderPspReference,
            OrderData: configJson.OrderData,
            // Identifiant du règlement (généré côté serveur, conservé lors d'une reprise de solde) —
            // permet de retrouver dans GestionPaiements uniquement les paiements de CE règlement.
            SessionPaiement: configJson.SessionPaiement,
            // Relances (solde, option, devis, libre) : transmis en metadata Adyen pour que le webhook
            // retrouve le dossier, sans dépendre du Referer (absent ou tronqué selon le navigateur).
            IdMail: configJson.IdMail,
            CleValidation: configJson.CleValidation,
        };

        // 1. Récupérer les differents moyens de paiement
        const paymentMethodsResponse = await getPaymentMethods();

        // Construit la configuration Adyen : environnement, callbacks onSubmit, onAdditionalDetails, onError
        const configuration = buildAdyenConfiguration(paymentMethodsResponse, infoPaiementParams, {
            submit: urlSubmit,
            submitAdditional: urlSubmitAdditional,
            submitInit: urlSubmitInitGestionPaiement,
            redirect: urlRedirect,
            createOrder: urlCreateOrder
        });

        // extrait les classes du SDK Adyen chargé via <script> dans la page
        const { AdyenCheckout, Dropin } = window.AdyenWeb; 

        // crée l'instance Adyen avec la configuration
        const checkout = await AdyenCheckout(configuration); 

        // 2. Instancier le Drop-in et l'afficher dans #dropin-container
        new Dropin(checkout, {
            disableFinalAnimation: true,
            paymentMethodsConfiguration: getPaymentMethodsConfiguration()
        }).mount("#dropin-container");

        // MutationObserver : attend l'apparition réelle des moyens de paiement (drop in) dans le DOM avant de completer son affichage avec multicarte et nom payeur
        const dropinContainer = document.querySelector('#dropin-container');
        if (dropinContainer) {
            const observer = new MutationObserver(() => {
                if (dropinContainer.querySelector('.adyen-checkout__payment-method')) {
                    observer.disconnect();
                    completerAffichageDropin();
                }
            });
            observer.observe(dropinContainer, { childList: true, subtree: true });
        }
    }

    // Récupère les moyens de paiement disponibles depuis le serveur
    async function getPaymentMethods() {
        const params = new URLSearchParams({
            Montant: configJson.Montant,
            CountryCode: configJson.CountryCode,
            CodePaysDestination: configJson.CodePaysDestination ?? '',
            Devise: configJson.Devise,
            TypeTunnelAchat: configJson.TypeTunnelAchat,
            AssuranceCB: configJson.AssuranceCB ?? false,
        });

        const pmResponse = await fetch('/PaiementAdyen/GetPaymentMethods', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
        });
        const paymentMethodsResponse = await pmResponse.json();

        // avec la version 6.10.0 du drop in , le nom card n'était pas traduit en français, on force le nom pour le type "scheme"
        if (Array.isArray(paymentMethodsResponse?.paymentMethods)) {
            paymentMethodsResponse.paymentMethods = paymentMethodsResponse.paymentMethods.map((method) =>
                method?.type === "scheme" ? { ...method, name: "Carte bancaire" } : method
            );
        }
        return paymentMethodsResponse;
    }

    // Construit la configuration Adyen : environnement, callbacks onSubmit, onAdditionalDetails, onError
    function buildAdyenConfiguration(paymentMethodsResponse, infoPaiementParams, urls) {
        return {
            environment: configJson.Environment,
            clientKey: configJson.ClientKey,
            countryCode: configJson.CountryCode,
            paymentMethodsResponse: paymentMethodsResponse,
            locale: "fr-FR",

            // Surcharge des traductions Adyen pour l'ANCV : libellé commercial "Chèque-Vacances Connect" à la place de "ANCV"
            translations: {
                "fr-FR": {
                    "ancv.input.label": "Identifiant Chèque-Vacances Connect",
                    "ancv.confirmPayment": "Utilisez votre application Chèque-Vacances Connect pour confirmer le paiement.",
                    "ancv.form.instruction": "L'application Chèque-Vacances Connect est nécessaire pour valider ce paiement.",
                    "ancv.beneficiaryId.invalid": "Saisissez une adresse e-mail ou un identifiant Chèque-Vacances Connect valide",
                },
            },

            // Rattache ce paiement à un Order Adyen existant (solde d'un paiement partiel précédent,
            // ex: ANCV) — évite de recréer un Order et permet à Adyen de cumuler les paiements liés
            // au même achat. Voir ANCVElement.createOrder() côté SDK : this.props.order court-circuite
            // l'appel à onOrderRequest.
            ...(infoPaiementParams.OrderPspReference ? {
                order: {
                    pspReference: infoPaiementParams.OrderPspReference,
                    orderData: infoPaiementParams.OrderData
                }
            } : {}),

            // Gérer la soumission — déclenché pour TOUS les moyens (CB, Pay by Bank, apple pay, google pay)
            onSubmit: async (state, component, actions) => {
                // Une redirection est déjà décidée (cycle précédent) : on n'entame pas un nouveau paiement.
                if (redirectionEnCours) {
                    actions.reject();
                    return;
                }

                masquerIncidentPaiement();

                let resultSubmit;
                try {

                    const requestData = buildRequestData(state, component, infoPaiementParams);
                    if (!requestData) {
                        return;
                    }

                    // PayByBank / ANCV : Adyen ne retourne pas paymentMethod.type pour un cancel
                    // → on l'inclut dans ReturnUrl pour qu'il soit disponible côté serveur via le model binder
                    infoPaiementParams.ReturnUrl = urls.redirect + '&MethodePaiement=' + encodeURIComponent(infoPaiementParams.MethodePaiement ?? '');

                    // initialisation des paiements dans la table gestionsPaiement
                    await submitPaymentInit(requestData, urls.submitInit);

                    // Envoyer les données de paiement au serveur Adyen
                    const responseSubmit = await fetch(urls.submit, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(requestData),
                    });

                    // réponse du serveur après le submit du paiement (peut contenir une action à faire, ex. 3DS, ou pas d'action si paiement refusé ou autorisé sans challenge)
                    resultSubmit = await responseSubmit.json();

                    if (!resultSubmit.resultCode && !resultSubmit.action) {
                        actions.reject();
                        return;
                    }

                    // transmet la réponse serveur au Drop-in
                    actions.resolve({
                        resultCode: resultSubmit.resultCode,
                        action: resultSubmit.action,
                        order: resultSubmit.order
                    });

                } catch (error) {
                    console.error("Erreur lors du submit:", error);
                    actions.reject();
                    return;
                }

                // hors du try/catch : une erreur ici ne peut plus appeler actions.reject() après actions.resolve()
                // Même logique qu'avant (v5) : pas de challenge → redirection tout de suite
                if (!resultSubmit.action) {
                    await paiementResult(infoPaiementParams, resultSubmit.resultCode, urls.redirect, resultSubmit.order);
                }
            },

            // Gérer les étapes supplémentaires (3DS, etc.)
            onAdditionalDetails: async (state, component, actions) => {
                // Une redirection est déjà décidée (cycle précédent) : on n'entame pas une nouvelle étape.
                if (redirectionEnCours) {
                    actions.reject();
                    return;
                }

                let resultSubmit3ds;
                try {

                    const requestData = {
                        ...state.data,          // garde le format Adyen (paymentMethod, browserInfo, etc.)
                        devise: infoPaiementParams.Devise
                    };
                    const responseSubmit3ds = await fetch(urls.submitAdditional, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(requestData)
                    });

                    // réponse du serveur après la validation du challenge 3DS ou autre étape supplémentaire
                    resultSubmit3ds = await responseSubmit3ds.json();

                    // l'appel serveur a échoué ou la réponse est invalide, on arrête le flux
                    if (!resultSubmit3ds.resultCode && !resultSubmit3ds.action) {
                        actions.reject();
                        return;
                    }

                    // transmet la réponse serveur au Drop-in
                    actions.resolve({
                        resultCode: resultSubmit3ds.resultCode,
                        action: resultSubmit3ds.action,
                        order: resultSubmit3ds.order
                    });

                } catch (error) {
                    console.error("Erreur lors du submit 3DS:", error);
                    actions.reject();
                    return;
                }

                // TODO DEBUG TEMPORAIRE — diagnostic #36921 incident ANCV malgré webhook AUTHORISATION, à retirer une fois le resultCode confirmé
                console.log("DEBUG ANCV resultSubmit3ds:", resultSubmit3ds);

                // Même logique qu'avant : fin 3DS (plus d'action) → redirection (ex. Cancel simulator).
                // C'est aussi ce chemin qui se déclenche pour ANCV (action.type "await") une fois le
                // paiement confirmé côté application ANCV.
                if (!resultSubmit3ds.action) {
                    await paiementResult(infoPaiementParams, resultSubmit3ds.resultCode, urls.redirect, resultSubmit3ds.order);
                }
            },

            // Requis par le composant ANCV (Orders API Adyen) : appelé au moment de soumettre
            // l'identification ANCV. Signature callback imposée par le SDK — ANCVElement fait
            // `new Promise((resolve, reject) => this.props.onOrderRequest(resolve, reject, data))`,
            // donc on DOIT appeler resolve/reject nous-mêmes ; retourner une Promise ne suffit pas
            // (elle est ignorée, et la Promise interne du SDK reste bloquée indéfiniment — pas d'erreur,
            // juste un chargement infini).
            onOrderRequest: async (resolve, reject) => {
                // Une redirection est déjà décidée (cycle précédent) : inutile de créer un nouvel Order.
                if (redirectionEnCours) {
                    reject();
                    return;
                }

                // ANCV : 1er callback d'une nouvelle tentative (avant onSubmit)
                masquerIncidentPaiement();

                try {
                    const response = await fetch(urls.createOrder, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams({
                            Reference: infoPaiementParams.Reference,
                            Montant: infoPaiementParams.Montant,
                            Devise: infoPaiementParams.Devise,
                        }).toString()
                    });
                    resolve(await response.json());
                } catch (error) {
                    reject(error);
                }
            },

            onError: (error, component) => {
                console.error("Erreur Adyen:", error);
                if (component && typeof component.setStatus === "function") {
                    component.setStatus("ready");
                }
            }
        };
    }

     // Construit le payload complet : données Adyen (state.data) + infos métier Terdav
    function buildRequestData(state, component, infoPaiementParams) {

        const paymentMethodType = state.data?.paymentMethod?.type;
        const isCardPayment = paymentMethodType === 'scheme';
        const carte = document.getElementById('carteCredit');

        infoPaiementParams.MethodePaiement = paymentMethodType;
        console.log("buildRequestData:", paymentMethodType);

        // Multicarte : uniquement pour la carte bancaire (scheme)
        if (isCardPayment && carte && carte.value == 2) {

            const montant1 = document.getElementById('montant1').value;
            const montant2 = document.getElementById('montant2').value;
            let montant = 0;

            if (document.getElementById('zoneCarte2').style.display == 'block') {
                montant = montant2;
                infoPaiementParams.ModePaiement = 3;
            } else {
                montant = montant1;
                infoPaiementParams.ModePaiement = 2;

                const montantMin = document.getElementById('hiddenMontantMin').value;
                const montantMax = document.getElementById('hiddenMontantMax').value;

                if (controleMulticarte(montantMin, montantMax) != "") {
                    component.setStatus('ready');
                    return null;
                }
            }

            infoPaiementParams.Montant = montant;
        } else {
            // CB simple, Pay by Bank, Apple Pay, Google Pay, etc.
            infoPaiementParams.ModePaiement = 1;
        }

        //on récupere le nom du payeur saisi dans le champ dédié
        if (!isCardPayment) { // googlepay, applepay
            infoPaiementParams.NomTitulaire = document.getElementById('nomPayeur')?.value.trim() ?? '';
        }
        else { // cb
            infoPaiementParams.NomTitulaire = document.querySelector('[name="holderName"]')?.value.trim() ?? ''
        }

        return {
            ...state.data,
            InformationsPaiement: infoPaiementParams
        };
    }

    // initialiser la table gestionPaiement avec l'etat "init"
    async function submitPaymentInit(requestData, url) {
        const response = await fetch(url, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        });
        if (!response.ok) {
            throw new Error(`submitPaymentInit échoué : ${response.status}`);
        }
    }

    // Configuration des moyens de paiement du Drop-in (carte, Google Pay, Apple Pay)
    function getPaymentMethodsConfiguration() {
        return {
            card: {
                hasHolderName: true,        // active le champ titulaire
                holderNameRequired: true,   // rend le champ obligatoire
                challengeWindowSize: "05",
                // Priorise CB pour les cartes co-badgées (CB + Visa/Mastercard)
                brands: ['cartebancaire', 'visa', 'mc'],
                placeholders: {
                    cardNumber: "1234 5678 9012 3456",
                    expiryDate: "MM/AA",
                    holderName: "J. Smith"
                }
            },
            googlepay: {
                amount: {
                    currency: configJson.Devise,
                    value: Math.round(configJson.Montant * 100)
                },
                countryCode: configJson.CountryCode,
                buttonType: "pay",
                ...(configJson.Environment === "Live" && configJson.GoogleMerchantId ? { // merchantId requis en production pour utiliser Google Pay
                    merchantId: configJson.GoogleMerchantId,
                    merchantName: configJson.GoogleMerchantName,
                } : {}),
            },
            applepay: {
                amount: {
                    currency: configJson.Devise,
                    value: Math.round(configJson.Montant * 100)
                },
                countryCode: configJson.CountryCode,
                buttonType: "pay",
            },
            paybybank: {
                name: "Virement instantané via Pay by Bank", // Surcharge le libellé affiché dans le Drop-in (le type technique "paybybank" reste inchangé)
            },
            ancv: {
                name: "Chèque-Vacances Connect", // Surcharge le libellé affiché dans le Drop-in (le type technique "ancv" reste inchangé)
            },
        };
    }

    // Gestion de l'affichage du multicarte et du champ nom payeur selon le moyen de paiement sélectionné
    function completerAffichageDropin() {

        const container = document.querySelector('#dropin-container');
        const divNomPayeur = document.getElementById('div-nomPayeur');

        if (!container) return;

        // Pay By Bank (virement)  : masqué si départ dans moins de 3 jours.
        if (!autorisePayByBank(configJson.DateDepart)) {
            masquerPayByBank(container);
        }

        // En mode carte 2 (multicarte, quuand le client a dejà payé carte 1), masque tous les moyens de paiement sauf la CB
        const zoneCarte2 = document.getElementById('zoneCarte2');
        if (zoneCarte2) {
            if (zoneCarte2.style.display === 'block') {
                masquerPaiementsNonCB(container);
            }
            const observerCarte2 = new MutationObserver(() => {
                if (zoneCarte2.style.display === 'block') {
                    masquerPaiementsNonCB(container);
                }
            });
            observerCarte2.observe(zoneCarte2, { attributes: true, attributeFilter: ['style'] });
        }

        // true = capture phase : s'exécute avant que le SDK Adyen / Google Pay reçoive le clic
        container.addEventListener('click', (e) => {

            const inputNomPayeur = divNomPayeur?.querySelector('input');
            const errorDiv = document.getElementById('nomPayeurError');

            // Lire le moyen cliqué depuis composedPath() — plus fiable que --selected car il permet d'obtenir le chemin réel de propagation avec un web component.
            // car Adyen n'a pas encore mis à jour ses classes CSS au moment du clic
            const path = e.composedPath();
            const clickedMethod = path.find(el => el.classList?.contains('adyen-checkout__payment-method'));
            if (!clickedMethod) return;

            const isScheme = clickedMethod.classList.contains('adyen-checkout__payment-method--scheme');

            // Pour tout moyen sauf CB : vérifier que le champ nom payeur est renseigné
            if (!isScheme)
            {
                const details = clickedMethod.querySelector('.adyen-checkout__payment-method__details');
                if (details && path.some(el => el === details) && inputNomPayeur && !inputNomPayeur.value.trim()) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    if (errorDiv) errorDiv.style.display = 'block';
                    inputNomPayeur.focus();
                    return;
                }
                if (errorDiv) errorDiv.style.display = 'none';
            }

            const carte = document.getElementById('carteCredit');
            const zoneCarte1 = document.getElementById('zoneCarte1'); // apparait quand on selectionne multicarte
            if (isScheme)
            {
                // CB : afficher le multicarte, masquer le champ nom payeur
                const isPayingCarte2 = zoneCarte2 && zoneCarte2.style.display === 'block';

                if (carte && !isPayingCarte2) document.querySelector('.formulaire__fieldset').style.display = 'block';
                if (zoneCarte1) zoneCarte1.style.display = (carte && carte.value == 2 && !isPayingCarte2) ? 'block' : 'none';
                if (divNomPayeur) divNomPayeur.style.display = 'none';
                if (inputNomPayeur) inputNomPayeur.removeAttribute('required');

            } else {

                // Autre moyen paiement : masquer le multicarte, afficher le champ nom payeur obligatoire
                document.querySelector('.formulaire__fieldset').style.display = 'none';
                if (zoneCarte1) zoneCarte1.style.display = 'none';

                // Réinitialiser à 1 carte côté serveur si multicarte était sélectionné
                if (carte && carte.value == 2) {
                    carte.value = 1;
                    carte.dispatchEvent(new Event('change'));
                }
                if (divNomPayeur) divNomPayeur.style.display = 'block';
                if (inputNomPayeur) inputNomPayeur.setAttribute('required', 'required');
            }

        }, true);
    }

    // récupère le numéro d'agence déjà affiché dans l'entête de la page (_header.cshtml)
    function getNumeroAgence() {
        const lien = document.querySelector('.header--help a[href^="tel:"]');
        return lien ? lien.textContent.trim() : '';
    }

    // masque tous les moyens de paiement sauf la CB
    function masquerPaiementsNonCB(container) {
        container.querySelectorAll('.adyen-checkout__payment-method').forEach(el => {
            if (!el.classList.contains('adyen-checkout__payment-method--scheme')) {
                el.style.display = 'none';
            }
        });
    }

  
  
    // masque le moyen de paiement Pay By Bank
    function masquerPayByBank(container) {
        const el = container.querySelector('.adyen-checkout__payment-method--paybybank');
        if (el) el.style.display = 'none';
    }

    // DateDepart au format "dd/MM/yyyy". Retourne false s'il reste moins de 3 jours avant le départ.
    function autorisePayByBank(dateDepart) {
        if (!dateDepart) return true;
        const [jour, mois, annee] = dateDepart.split('/').map(Number);
        if (!jour || !mois || !annee) return true;

        const dateDepartDate = new Date(annee, mois - 1, jour);
        const aujourdHui = new Date();
        aujourdHui.setHours(0, 0, 0, 0);

        const joursAvantDepart = Math.round((dateDepartDate - aujourdHui) / (1000 * 60 * 60 * 24));
        return joursAvantDepart >= 3;
    }

    // Gestion de l'affichage de la page de resultat (page confirmation ou echec)
    async function paiementResult(infoPaiementParams, resultCode, urlRedirect, order) {

        // Posé en tout premier, avant tout await : bloque immédiatement tout cycle onSubmit/
        // onAdditionalDetails/onOrderRequest concurrent qui n'aurait pas encore démarré (voir déclaration
        // de redirectionEnCours en haut du fichier).
        redirectionEnCours = true;

        // PartiallyAuthorised (ex: ANCV réglé partiellement) : le paiement a bien été pris en compte,
        // mais il reste un solde à régler — ce n'est ni un succès complet ni un refus. Le serveur
        // décide de la suite (reproposer un moyen de paiement) via MontantRestant.
        if (resultCode == "Authorised" || resultCode == "PartiallyAuthorised") {
            infoPaiementParams.SuccesPaiement = true;
        }
        else {
            infoPaiementParams.SuccesPaiement = false;
        }

        if (order) {
            // order.remainingAmount reflète ce qu'il reste à payer APRÈS cette étape. Le montant
            // réellement autorisé par CETTE étape peut être inférieur au montant demandé (ex: solde
            // ANCV insuffisant) — infoPaiementParams.Montant ne contient que le montant demandé, il
            // faut le recalculer : demandé - solde restant après paiement (en minor units pour éviter
            // les imprécisions flottantes).
            const montantDemandeMinor = Math.round(infoPaiementParams.Montant * 100);
            const montantRestantMinor = order.remainingAmount?.value ?? 0;
            infoPaiementParams.Montant = (montantDemandeMinor - montantRestantMinor) / 100;

            if (montantRestantMinor > 0) {
                infoPaiementParams.MontantRestant = montantRestantMinor / 100;
                infoPaiementParams.OrderPspReference = order.pspReference;
                infoPaiementParams.OrderData = order.orderData;
            }
        }

        console.log(resultCode);
        // récupere l'url de redirection (confirmation ou refus de paiement)
        const responseRedirect = await fetch(urlRedirect, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(infoPaiementParams)
        });
        const redirectResult = await responseRedirect.json();
       
        window.location.href = redirectResult.urlReturn;
    }
}